<template>
  <div class="informBox flexCol">
    <div class="campusBox rowAc" @click="showPicker = true">
      <div>{{ campus }}</div>
      <div
        class="icon"
        :class="[showPicker ? 'icon-arrow-up' : 'icon-arrow-down']"
      ></div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        ref="selectCampus"
        :columns="campusNames"
        :default-index="campusIdx"
        @cancel="showPicker = false"
        @confirm="selectCampusConfirm"
      />
    </van-popup>
    <div class="calendarBox rowJbAc" @click="show = true">
      <div class="text rowAc">
        <div class="icon-calendar"></div>
        <div>请选择日期</div>
      </div>
      <div class="icon-arrow-left arrowIcon" v-if="!dateRangeText"></div>
      <div class="date" v-else>{{ dateRangeText }}</div>
    </div>
    <van-calendar
      v-model="show"
      @closed="closedCalendar"
      ref="calendar"
      type="range"
      :min-date="minDate"
      :default-date="defaultDate"
      @confirm="onConfirm"
      color="#6985FF"
    />
    <div class="list">
      <div class="emptyBox colAc" v-if="list.length == 0">
        <img src="../../assets/static/emptyList.png" alt="" />
        <div>暂时还没有通知哦</div>
      </div>
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, index) in list" :key="index">
          <div class="item">
            <div class="itemTop rowJbAc">
              <div class="rowAc">
                <img class="topImg" src="../../assets/static/inform.png" />
                <div class="informType">{{ item.typeName }}</div>
              </div>
              <div class="informDate">{{ item.createTime }}</div>
            </div>
            <div class="informTitle center">{{ item.title }}</div>
            <div class="informContent">{{ item.note }}</div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import {
  getNoticeRecordsAPI,
  getInstitutionCampusAPI,
  getAuthsRefreshAPI,
} from "../../utils/api/api";

export default {
  data() {
    return {
      total: 0, // 总条数
      current: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      dateRange: ["", ""],
      defaultDate: [new Date(), new Date()],
      minDate: new Date(2016, 0, 1),
      campus: "",
      campusCode: "",
      customerId: "",

      showPicker: false,
      campusNames: [],
      campusList: [],
      show: false,

      list: [],
    };
  },
  created() {
    if (this.$common.getCache('institutionCode')) {
      this.campusNames = [];
    //   var institutionCode = localStorage.getItem("institutionCode");
        var institutionCode = this.$common.getCache('institutionCode')

      getInstitutionCampusAPI({ code: institutionCode }).then((res) => {
        console.log("校区列表：", res);
        if (res.resultCode == 200 && res.data) {
          res.data.forEach((item) => {
            this.campusNames.push(item.name);
            if (this.$common.getCache('campusCode')) {
              if (item.code == this.$common.getCache('campusCode')) {
                this.campus = item.name;
                this.campusCode = item.code;
              }
            }
            this.campusList.push({
              campusName: item.name,
              campusCode: item.code,
            });
          });
        }
      });
    }
    this.getList();
  },
  computed: {
    campusIdx() {
      return this.campusNames.findIndex((item) => {
        return item == this.campus;
      });
    },
    dateRangeText() {
      if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
        return this.dateRange[0] + " 至 " + this.dateRange[1];
      } else {
        return false;
      }
    },
  },
  watch: {
    // 取消选中 校区时选中索引改为当前选中
    showPicker() {
      if (!this.showPicker) {
        this.$refs.selectCampus.setIndexes([this.campusIdx]);
      }
    },
  },
  methods: {
    // 选择校区确认
    async selectCampusConfirm(value) {
      this.showPicker = false;
      if (this.campus == value) {
        return;
      }
      this.campus = value;
      this.campusCode = this.campusList[this.campusIdx].campusCode;
      var res = await getAuthsRefreshAPI({ campusCode: this.campusCode });
      if (res.resultCode == 200) {
        // localStorage.setItem("campusCode", res.data.campusCode);
        // localStorage.setItem("institutionCode", res.data.institutionCode);
        // localStorage.setItem("token", res.data.token);
        this.$common.setCache('institutionCode',res.data.institutionCode)
        this.$common.setCache('campusCode',res.data.campusCode)
        this.$common.setCache('token',res.data.token)
      }
      this.current = 1;
      this.list = [];
      this.getList();
    },
    // 改变日期格式
    formatDate(date) {
      return `${date.getFullYear()}-${this.changeNum(
        date.getMonth() + 1
      )}-${this.changeNum(date.getDate())}`;
    },
    onLoad() {
      if (this.dateRangeText) {
        setTimeout(() => {
          this.current++;
          this.getList();
        }, 500);
      } else {
        this.loading = false;
      }
    },
    // 日期选中点击确认
    onConfirm(date) {
      this.current = 1;
      this.total = 0;
      this.dateRange = [];
      this.list = [];
      const [start, end] = date;
      this.defaultDate = [start, end];
      this.show = false;
      this.dateRange.push(this.formatDate(start));
      this.dateRange.push(this.formatDate(end));
      this.getList();
    },
    changeNum(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return num;
      }
    },

    // 选择校区确认
    // selectCampusConfirm(value) {
    //   this.showPicker = false;
    //   if (this.campus == value) {
    //     return;
    //   }
    //   this.campus = value;
    //   this.customerId = this.campusList[this.campusIdx].customerId;
    //   this.campusCode = this.campusList[this.campusIdx].campusCode;
    //   this.current = 1;
    //   this.list = [];
    //   this.getList();
    // },
    // 取消选择校区
    // cancelPicker() {
    //   this.showPicker = false;
    //   this.$refs.selectCampus.setIndexes(this.campusIdx);
    // },
    // 日历弹框消失，重新设置默认选中日期
    closedCalendar() {
      this.$refs.calendar.reset();
    },
    // 获取列表
    getList() {
      var obj = {
        currPage: this.current,
        pageSize: this.pageSize,
      };
      if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
        obj["startDate"] = this.dateRange[0];
        obj["endDate"] = this.dateRange[1];
      }
      getNoticeRecordsAPI(obj).then((res) => {
        console.log("通知列表：", res);
        if (res.resultCode == 200) {
          if (res.data) {
            this.loading = false;
            this.total = res.data.totalCount;
            if (res.data.dataList.length == 0) {
              this.finished = true;
              return;
            } else {
              this.finished = false;
            }
            res.data.dataList.forEach((item) => {
              this.list.push(item);
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.informBox {
  width: 100%;
  height: 100%;
  background: #f4faff;
  padding: 12px 0 0 0.15rem;
  box-sizing: border-box;
  overflow: auto;
}
.campusBox {
  font-size: 16px;
  font-weight: 500;
  color: #333843;
}
.icon {
  margin-left: 4px;
}
.calendarBox {
  padding: 0 10px 0 12px;
  height: 32px;
  background: #fefffe;
  border-radius: 16px;
  margin-top: 18px;
  margin-bottom: 8px;
  color: #333843;
  line-height: 32px;
  .text {
    > div:first-child {
      margin-right: 4px;
    }
    font-size: 14px;
  }
  .arrowIcon {
    font-size: 16px;
    color: #9ea8ba;
  }
  .date {
    font-size: 14px;
    color: #6985ff;
  }
}
.list {
  padding-right: 0.15rem;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
}
.item {
  margin-top: 12px;
  padding: 16px 12px 16px;
  background: #ffffff;
  box-shadow: 4px 4px 11px 0px rgba(229, 236, 243, 0.8),
    -9px -9px 22px 0px rgba(255, 255, 255, 0.5);
  border-radius: 6px;
}
.itemTop {
  padding: 0px 4px;
  height: 21px;

  .topImg {
    width: 22px;
    height: 18px;
    margin-right: 6px;
  }
  .informType {
    font-size: 15px;
    color: #333843;
    line-height: 21px;
  }
  .informDate {
    font-size: 13px;
    color: #666666;
  }
}
.informTitle {
  color: #333843;
  font-weight: 500;
  font-size: 18px;
  margin-top: 23px;
  margin-bottom: 16px;
  height: 25px;
  line-height: 25px;
}
.informContent {
  color: #333843;
  font-size: 14px;
  line-height: 25px;
  white-space: pre-wrap;
}
.emptyBox {
  img {
    width: 165px;
    height: 114px;
    margin-top: 40px;
  }
  > div {
    font-size: 13px;
    color: #9ea8ba;
    line-height: 19px;
  }
}
</style>